import { WindowPendo } from '../models/Pendo';

export const getWindowPendo = (): WindowPendo => {
  return window;
};
